import { render } from "./FuneralInvitationForm.vue?vue&type=template&id=4ade3fa2&scoped=true"
import script from "./FuneralInvitationForm.vue?vue&type=script&lang=js"
export * from "./FuneralInvitationForm.vue?vue&type=script&lang=js"

import "./FuneralInvitationForm.vue?vue&type=style&index=0&id=4ade3fa2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ade3fa2"]])

export default __exports__